import { render, staticRenderFns } from "./index.vue?vue&type=template&id=396afdf9&scoped=true&lang=html&"
import script from "./appDownload.js?vue&type=script&lang=js&"
export * from "./appDownload.js?vue&type=script&lang=js&"
import style0 from "./appDownload.styl?vue&type=style&index=0&id=396afdf9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396afdf9",
  null
  
)

export default component.exports